import React from 'react';
import { RemoveModificationButton } from '../RemoveModificationButton/RemoveModificationButton';
import * as S from './ProductItemSummary.styled';
export const ProductItemSummary = ({ label, onRemoveModificationClick, }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Item, null,
            label,
            React.createElement(RemoveModificationButton, { ariaLabel: "Remove promo code", onClick: onRemoveModificationClick }))));
};
